
const SpecializedServicesSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Specialized Training Services
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              We provide specialized training for hazardous waste operations and emergency response (HAZWOPER). HAZWOPER classes include training for chemical spill cleanup, lead asbestos, and mold remediation. Our HAZWOPER training covers the 40-hour, 24-hour, and 8-hour requirements. We prepare your team for any emergency response situation.
            </p>
          </div>
          
          <div className="text-center mt-8">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecializedServicesSection;